/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayerContractRules
 */
export interface PayerContractRules {
    /**
     * Contract rules content as text
     */
    rules?: string;
}

/**
 * Check if a given object implements the PayerContractRules interface.
 */
export function instanceOfPayerContractRules(value: object): value is PayerContractRules {
    return true;
}

export function PayerContractRulesFromJSON(json: any): PayerContractRules {
    return PayerContractRulesFromJSONTyped(json, false);
}

export function PayerContractRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerContractRules {
    if (json == null) {
        return json;
    }
    return {
        
        'rules': json['rules'] == null ? undefined : json['rules'],
    };
}

export function PayerContractRulesToJSON(json: any): PayerContractRules {
    return PayerContractRulesToJSONTyped(json, false);
}

export function PayerContractRulesToJSONTyped(value?: PayerContractRules | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rules': value['rules'],
    };
}

